import { getUnixTime } from 'date-fns'

export function useUnixTimestamp() {
  return getUnixTime(new Date())
}
